export default {
  RENEW_VERIFY_NIP_COMMAND_SERVICE: Symbol.for('RENEW_VERIFY_NIP_COMMAND_SERVICE'),
  RENEW_VERIFY_NIP_REPOSITORY: Symbol.for('RENEW_VERIFY_NIP_REPOSITORY'),
};
